var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.125 0H6.875C3.07804 0 0 3.07804 0 6.875V37.125C0 40.922 3.07804 44 6.875 44H37.125C40.922 44 44 40.922 44 37.125V6.875C44 3.07804 40.922 0 37.125 0Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 22C33 15.95 28.05 11 22 11C15.95 11 11 15.95 11 22C11 27.5 14.9875 32.0375 20.2125 32.8625V25.1625H17.4625V22H20.2125V19.525C20.2125 16.775 21.8625 15.2625 24.3375 15.2625C25.575 15.2625 26.8125 15.5375 26.8125 15.5375V18.2875H25.4375C24.0625 18.2875 23.65 19.1125 23.65 19.9375V22H26.675L26.125 25.1625H23.5125V33C29.0125 32.175 33 27.5 33 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3a79ed095a6a764fbe734e5daae9808b.svg";
export { ForwardRef as ReactComponent };